import {
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  inject,
  signal,
} from '@angular/core';
import { NgClass } from '@angular/common';
import { SidebarItemStore } from '@core/components/sidebar/components/sidebar-item/sidebar-item.store';
import { SidebarItemCollapsedIconComponent } from '@core/components/sidebar/components/sidebar-item/item/collapsed/icon/sidebar-item-collapsed-icon.component';
import { SidebarItemCollapsedHoverComponent } from '@core/components/sidebar/components/sidebar-item/item/collapsed/hover/sidebar-item-collapsed-hover.component';

@Component({
  selector: 'app-sidebar-item-collapsed',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    SidebarItemCollapsedIconComponent,
    SidebarItemCollapsedHoverComponent,
  ],
  template: `
    <li class="my-0.5 flex w-full">
      <app-sidebar-item-collapsed-icon
        (mouseenter)="onMouseEnter()"
        (mouseleave)="cancelOnHoverDuringBuffer()">
      </app-sidebar-item-collapsed-icon>

      @if (hasSubPages()) {
        <app-sidebar-item-collapsed-hover
          class="absolute z-50"
          [ngClass]="{ invisible: !hover() }"
          (mouseleave)="onMouseLeave()"
          (exitItem)="onMouseLeave()">
        </app-sidebar-item-collapsed-hover>
      }
    </li>
  `,
})
export class SidebarItemCollapsedComponent {
  /** INJECTIONS **/
  /****/
  private readonly store = inject(SidebarItemStore);

  /****/
  private readonly destroyRef = inject(DestroyRef);

  /** PROPERTIES **/
  /****/
  protected readonly hover = signal<boolean>(false);

  /****/
  protected readonly hasSubPages = computed(() => !!this.store.subPages());

  /****/
  private readonly _DEBOUNCE_TIME = 600;

  /****/
  private _timeout: NodeJS.Timeout;

  /****/
  private _hoverBufferActive = false;

  constructor() {
    this.destroyRef.onDestroy(() => clearTimeout(this._timeout));
  }

  protected onMouseEnter() {
    this._hoverBufferActive = true;
    clearTimeout(this._timeout);

    this._timeout = setTimeout(() => {
      this.hover.set(true);
      this._hoverBufferActive = false;
    }, this._DEBOUNCE_TIME);
  }

  protected onMouseLeave() {
    clearTimeout(this._timeout);
    setTimeout(() => this.hover.set(false), 0);
  }

  protected cancelOnHoverDuringBuffer() {
    if (this._hoverBufferActive) this.onMouseLeave();
  }
}
